import MainPage from './Views/MainPage';

function App() {
  return (
    <MainPage />
  );
}

export default App;
